import { PerformanceReviewOverviewPageTeamsFragment } from 'generated/resources/graphql'

import Filter from 'modules/core/components/Filter'
import i18n from 'modules/core/lib/i18n'

import { useFilter } from '../context'

type TeamsFilterProps = {
  teams: PerformanceReviewOverviewPageTeamsFragment[]
}

export const TeamsFilter = ({ teams }: TeamsFilterProps) => {
  const { value, setValue } = useFilter('teamIds')

  const options =
    teams.map((team) => ({
      label: team.name,
      value: team.id,
    })) ?? []

  if (options.length === 0) return null

  return (
    <Filter.MultipleChoice
      label={i18n.t('performance_process.reviews.filters.teams')}
      value={value}
      options={options}
      onValueChange={(newValue) => setValue(newValue ?? [])}
    />
  )
}
